export const API_BASE_URL = 'https://admin.brainershub.in/api';
export const BASE_URL = 'https://admin.brainershub.in';

// export const API_BASE_URL = 'http://localhost/brainershubproject/brainershub/api';
// export const BASE_URL = 'http://localhost/brainershubproject/brainershub';

export const razorpay_key = 'rzp_live_SmOnTzTXtrgvn0';
export const institute_id = '8';
// export const razorpay_key = 'rzp_test_Rf5wtIGvhjhFUi';
